import React from 'react'
import { Container, Row, Col, Card, ListGroup } from "react-bootstrap";
import flutterImg from './../../Images/cour3.PNG'; // replace with your Flutter-related image
import Footer from '../Footer';
import Enquiry from '../enquiry';
import { Helmet } from 'react-helmet';

const FrontEndMobile = () => {

    return (
        <>
            <Helmet>
                <title>Front-End Mobile Development Course in Coimbatore | GT SOFTWARE ACADEMY</title>
                <meta
                    name="description"
                    content="GT SOFTWARE ACADEMY in Coimbatore offers the best Front-End Mobile Development training program with Flutter, React Native, Dart, JavaScript, HTML, CSS, responsive design, UI/UX principles, real-time projects, and placement support. Designed for students, professionals, and aspiring developers to become job-ready Front-End Mobile Developers."
                />
                <meta
                    name="keywords"
                    content="
Front-End Mobile, Front-End Mobile Developer, Mobile UI Development, Mobile UX Design, Flutter, React Native, Dart, JavaScript, HTML, CSS, Responsive Mobile Design, Mobile App UI, Mobile App UX, Mobile Interface, Mobile Frontend, App Development, Software Development, Mobile Applications, Cloud Deployment, Secure Mobile Apps, Authentication, Authorization, REST API Integration, Mobile Projects, Real-time Mobile, Hands-on Mobile, Mobile Case Studies, Mobile Frameworks, Front-End Programming, Mobile Design Patterns, Agile, Scrum, DevOps, Mobile Career, Mobile Jobs, Mobile Internship, Mobile Placement, Job-Ready Mobile, Industry Experts, Project-Based Mobile, Professional Mobile Developer, Certified Mobile Developer, Career in Mobile, Mobile Mentors, Instructor-Led Mobile Training, Best Mobile Institute, Top Mobile Training, Comprehensive Mobile Curriculum, End-to-End Front-End Mobile Development, Real-world Mobile Projects, Scalable Mobile Applications, GT SOFTWARE ACADEMY, GTSoftware, GTCollege, Training Institute, Coimbatore, Tamil Nadu, India, Students, Beginners, Professionals, Engineers, Developers
"
                />
                <meta
                    property="og:title"
                    content="Front-End Mobile Development Course in Coimbatore | GT SOFTWARE ACADEMY"
                />
                <meta
                    property="og:description"
                    content="Master Front-End Mobile Development with GT SOFTWARE ACADEMY, Coimbatore. Learn Flutter, React Native, Dart, JavaScript, UI/UX design, responsive layouts, and real-world projects with job-oriented training and placement assistance."
                />
                <meta
                    property="og:image"
                    content="https://gtcollege.in/path-to-image/front-end-mobile-course.PNG"
                />
                <meta property="og:type" content="website" />
                <meta name="robots" content="index, follow" />
                <link rel="canonical" href="https://www.gtcollege.in/info-mobile_front_end" />

            </Helmet>

            <Container className="py-5">

                {/* Intro Section */}
                <Row className="mb-5 justify-content-center text-center">
                    <Col md={12} lg={12}>
                        <h2 className="fw-bold mb-3">Welcome to GT SOFTWARE ACADEMY</h2>
                        <p className="text-muted">
                            At GT SOFTWARE ACADEMY, we offer a specialized <strong>Front-End Mobile Development with Flutter</strong> program
                            designed to equip aspiring developers with the skills to create stunning, responsive, and user-friendly mobile applications.
                            Learn how to design and build cross-platform apps for <strong>Android</strong> and <strong>iOS</strong> using a single codebase with Flutter,
                            while gaining hands-on experience through real-world projects.
                        </p>
                    </Col>
                </Row>


                {/* Why Flutter Section */}
                <Row className="mb-5 lg e1" style={{ padding: "10px", opacity: "0.9", backgroundColor: "black" }}>
                    <Col md={6} style={{ padding: "15px" }}>
                        <img src={flutterImg} style={{ height: "200px" }} className='a33' alt="Flutter" />
                    </Col>
                    <Col md={6} className="d-flex align-items-center">
                        <div>
                            <h3 className="fw-bold mb-3" style={{ color: "#7FB300" }}>Why Front-End Mobile Development with Flutter?</h3>
                            <p style={{ color: "white" }}>
                                Flutter has become one of the most powerful frameworks for mobile app development.
                                Its <b>hot reload</b>, <b>rich widget library</b>, and <b>native-like performance </b>
                                make it the first choice for developers and companies worldwide.
                                A Flutter-skilled Front-End Mobile Developer can bring designs to life quickly,
                                creating seamless and engaging user experiences.
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* What You'll Learn */}
                <Row className="mb-5">
                    <Col>
                        <h3 className="fw-bold text-center mb-4">What You'll Learn</h3>
                    </Col>
                </Row>
                <Row>
                    {/* Flutter Fundamentals */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">1. Flutter Fundamentals</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">📱 Introduction to Flutter and Dart</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">📂 Project structure and setup</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🔧 Understanding widgets (Stateless vs Stateful)</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* UI Development */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">2. Building User Interfaces</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🎨 Designing beautiful layouts with widgets</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">📐 Rows, Columns, Containers, and Stacks</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">📱 Responsive UI for multiple screen sizes</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* UI/UX Best Practices */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">3. UI/UX Best Practices</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🧭 Smooth navigation & user flows</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">📱 Material Design & Cupertino widgets</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🎨 Theming, styling & consistency</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* State Management */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">4. State Management</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">⚡ Managing state with setState, Provider & GetX</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🔄 Reactive programming in Flutter</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">✍️ Handling user input & data updates</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* API Integration */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">5. API Integration</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🌐 Connecting Flutter apps to REST APIs</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">📊 Fetching and displaying real-time data</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🔑 Handling JSON, authentication & errors</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Animations */}
                    <Col md={6} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">6. Animations & Interactions</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🎬 Smooth transitions & animations</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🖐️ Gesture detection & interactions</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🚀 Hero animations & page transitions</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Testing & Debugging */}
                    <Col md={12} className="mb-4">
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">7. Testing & Debugging</Card.Title>
                                <ListGroup variant="flush">
                                    <ListGroup.Item className="border-0 ps-0">🔍 Debugging UI with Flutter DevTools</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">🧪 Writing widget & integration tests</ListGroup.Item>
                                    <ListGroup.Item className="border-0 ps-0">⚡ Performance & optimization</ListGroup.Item>
                                </ListGroup>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Projects Section */}
                <Row className="mb-5">
                    <Col md={12}>
                        <Card className="rounded-2 h-100">
                            <Card.Body>
                                <Card.Title className="fw-bold">Real-World Projects & Case Studies</Card.Title>
                                <ul>
                                    <li>💬 Build a chat app interface with Flutter widgets</li>
                                    <li>🛒 Create a responsive e-commerce app UI with API integration</li>
                                    <li>📊 Capstone projects simulating real industry workflows</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Enquiry />
                </Row>
                {/* Why Choose Us */}
                <Row className="mt-5">
                    <Col>
                        <h3 className="fw-bold text-center mb-4">Why Choose GT SOFTWARE ACADEMY?</h3>
                    </Col>
                </Row>
                <Row className="mt-5 text-center">
                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>👨‍🏫</h2>
                                <h5 className="fw-bold mt-2">Expert Flutter Training</h5>
                                <p className="text-muted">
                                    Learn from experienced Flutter developers with hands-on expertise.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>💻</h2>
                                <h5 className="fw-bold mt-2">Hands-On Projects</h5>
                                <p className="text-muted">
                                    Apply knowledge by building production-ready mobile UIs.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>📚</h2>
                                <h5 className="fw-bold mt-2">Industry-Relevant Curriculum</h5>
                                <p className="text-muted">
                                    Stay ahead with Flutter’s latest updates and ecosystem tools.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col md={3} className="mb-4">
                        <Card className="h-100 shadow-sm border-0.5 rounded-3">
                            <Card.Body>
                                <h2>🚀</h2>
                                <h5 className="fw-bold mt-2">Job-Ready Skills</h5>
                                <p className="text-muted">
                                    By the end of the program, you’ll be job-ready to design & build Flutter-based apps.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

            </Container>
            <Footer />
        </>
    )
}

export default FrontEndMobile;
